import { render, staticRenderFns } from "./DraftForm.vue?vue&type=template&id=94909c40&"
import script from "./DraftForm.vue?vue&type=script&lang=js&"
export * from "./DraftForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports